import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue';
import Banner from '@/shared/components/Banner.vue';
import { BOT_STUDIO_ENABLED } from '@/store/app/featureTypes';
import UpgradeModal from '@/features/bots/components/UpgradeModal.vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpgradeBanner',
  setup(__props) {

const store = useStore();
const isWorkspaceFeatureEnabled = (feature: string, defaultValue = false) =>
  computed(() => store.getters.isWorkspaceFeatureEnabled(feature, defaultValue));
const upgradeModalOpen = ref(false);

const botStudioEnabled = computed(() => isWorkspaceFeatureEnabled(BOT_STUDIO_ENABLED, true));

function closeUpgradeModal() {
  upgradeModalOpen.value = false;
}

function openUpgradeModal() {
  upgradeModalOpen.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!botStudioEnabled.value)
      ? (_openBlock(), _createBlock(Banner, {
          key: 0,
          type: "info"
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "banner-text" }, "Upgrade to make your flows live", -1)),
            _createElementVNode("strong", null, [
              _createElementVNode("a", {
                id: "upgrade-link",
                class: "is-underlined",
                onClick: openUpgradeModal
              }, "Upgrade")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (upgradeModalOpen.value)
      ? (_openBlock(), _createBlock(UpgradeModal, {
          key: 1,
          onClose: closeUpgradeModal
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})